var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    [
      _c("RegistrarClient", { ref: "registrarClient" }),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("base-card", [
            _c("iframe", {
              staticStyle: { "min-height": "100vh" },
              attrs: {
                src: "https://hiopos.saas.com.co/logs/colombia",
                width: "100%",
                frameborder: "0",
              },
            }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }